import { useState } from 'react';

export const GeneralButton = ({
  w = 64,
  h = 16,
  buttonText,
  disabled,
  onClick = () => { }
}) => {
  const [isShown, setIsShown] = useState(false);

  const base =
    "border-2 font-bold shadow-lg";

  const size = `w-${w} h-${h}`;

  const enabledStyles = isShown
    ? "bg-orange-500 text-white border-orange-500"
    : "text-orange-500 border-orange-500";

  const disabledStyles =
    "text-gray-400 border-gray-400 bg-transparent cursor-not-allowed";

  return (
    <button
      className={`${base} ${size} ${disabled ? disabledStyles : enabledStyles}`}
      onMouseEnter={() => !disabled && setIsShown(true)}
      onMouseLeave={() => !disabled && setIsShown(false)}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
    >
      {disabled ? "ATTENDI" : buttonText}
    </button>
  );
};
